module.exports = __webpack_public_path__ + "img/enemy_move_random.86b65728.svg";